<template>
  <div id="content-wrapper">
    <b-tabs content-class="mt-3">
      <b-tab
        :active="!activeTab || activeTab === `#${GROUP_TAB.THONG_TIN_GROUP}`"
        @click="
          changeCurrentTab(
            GROUP_TAB.THONG_TIN_GROUP,
            NAME_GROUP_TAB.THONG_TIN_GROUP
          )
        "
        title="Thông tin nhóm người dùng"
      >
        <div class="box box-form pb-5" v-if="!activeTab || activeTab == `#${GROUP_TAB.THONG_TIN_GROUP}`">
          <FormGroup
            :form="chiTietGroup"
            :readonly="false"
            ref="cap-nhat-group"
          />
          <!-- T4+5 UC13.4: modal confirm khi bật bắt buộc OTP OFF->ON. -->
          <MandateOtpConfirmModal
            :modal-id="MANDATE_MODAL_ID"
            entity-label="nhóm"
            :count="mandateAffectedCount"
            :sample-names="mandateAffectedSampleNames"
            @confirm="onConfirmMandateGroup"
          />
          <div class="d-flex float-right">
            <base-button
              @click="capNhatGroup()"
              class="btn btn-main ml-2"
              button="Lưu"
              :disabled="isLoadingAction"
              v-if="this.$route.params.id !== 'tao-moi'"
            >
              Cập nhật
            </base-button>

            <base-button
              v-if="this.$route.params.id === 'tao-moi'"
              @click="taoMoiGroup()"
              class="btn btn-main ml-2"
              button="Lưu"
              color="btn-success"
            >
              Lưu
            </base-button>
            <base-button
              @click="lamMoi()"
              class="btn btn-main ml-2"
              button="Làm mới"
              color="btn-warning"
            >
              Làm mới
            </base-button>
            <base-button
              button="Đóng"
              @click="boQua()"
              class="btn btn-line"
              :disabled="isLoadingAction"
            >
              Đóng
            </base-button>
          </div>
        </div>
      </b-tab>
      <b-tab
        :active="activeTab === `#${GROUP_TAB.VAI_TRO}`"
        @click="changeCurrentTab(GROUP_TAB.VAI_TRO, NAME_GROUP_TAB.VAI_TRO)"
        title="Vai trò"
        v-if="!(disabledItem && this.$route.params.id === 'tao-moi')"
      >
        <div class="box box-form" v-if="activeTab == `#${GROUP_TAB.VAI_TRO}`">
          <div class="row">
            <div class="col-md-6 col-xs-12">
              <b-form-group
                label="Ứng dụng"
                label-for="ung-dung"
                label-class="font-weight-bold font-size-16"
              >
                <v-select
                  :options="danhSachAppNoiBo"
                  id="id"
                  label="name"
                  :reduce="(app) => app.id"
                  v-model="internalAppId"
                  :readonly="true"
                  placeholder="Chọn ứng dụng"
                >
                  <span slot="no-options">
                    Không tìm thấy dữ liệu
                  </span></v-select
                >
              </b-form-group>
            </div>
          </div>
          <DanhSachVaiTroTheoGroup
            :chiTietGroup="chiTietGroup"
            :key="`thuoc-group-${chiTietGroup.Id}`"
            :readonly="false"
            :appId="internalAppId"
            ref="danhSachVaiTroTheoGroup"
          />
        </div>
      </b-tab>
      <b-tab
        :active="activeTab === `#${GROUP_TAB.NGUOI_DUNG}`"
        @click="
          changeCurrentTab(GROUP_TAB.NGUOI_DUNG, NAME_GROUP_TAB.NGUOI_DUNG)
        "
        title="Người dùng"
        v-if="!(disabledItem && this.$route.params.id === 'tao-moi')"
      >
        <div class="box box-form" v-if="activeTab == `#${GROUP_TAB.NGUOI_DUNG}`">
          <DanhSachNguoiDungTheoGroup
            :chiTietGroup="chiTietGroup"
            :key="`thuoc-group-${chiTietGroup.Id}`"
            :readonly="false"
            ref="danhSachNguoiDungThuocGroup"
          />
        </div>
      </b-tab>

      <b-tab
        :active="activeTab === `#${GROUP_TAB.QUYEN}`"
        @click="changeCurrentTab(GROUP_TAB.QUYEN, NAME_GROUP_TAB.QUYEN)"
        title="Phân quyền"
        v-if="!(disabledItem && this.$route.params.id === 'tao-moi')"
      >
        <div class="box box-form" v-if="activeTab == `#${GROUP_TAB.QUYEN}`">
          <div class="row">
            <div class="col-md-6 col-xs-12">
              <b-form-group
                label="Ứng dụng"
                label-for="ung-dung"
                label-class="font-weight-bold font-size-16"
              >
                <v-select
                  :options="danhSachAppNoiBo"
                  id="id"
                  label="name"
                  :reduce="(app) => app.id"
                  v-model="internalAppId"
                  :readonly="true"
                  placeholder="Chọn ứng dụng"
                >
                  <span slot="no-options">
                    Không tìm thấy dữ liệu
                  </span></v-select
                >
              </b-form-group>
            </div>
          </div>
          <DanhSachQuyenTrongGroup
            :chiTietNguoiDung="chiTietGroup"
            :key="`thuoc-group-${chiTietGroup.Id}`"
            :readonly="false"
            :appId="internalAppId"
            ref="danhSachQuyenTrongGroup"
          />
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import {
  BO_QUA_BUTTON_LABEL,
  ROUTE_NAME,
  GROUP_TAB,
} from "@/constants/constants";
import {
  CAP_NHAT_GROUP_THANH_CONG,
  THEM_MOI_GROUP_THANH_CONG,
} from "@/constants/message";
import FormGroup from "@/components/pages/quan-tri-he-thong/group/FormGroup";
import DanhSachNguoiDungTheoGroup from "@/components/pages/quan-tri-he-thong/nguoi-dung/DanhSachNguoiDungTheoGroup";
import DanhSachVaiTroTheoGroup from "@/components/pages/quan-tri-he-thong/vai-tro/DanhSachVaiTroTheoGroup";
import DanhSachQuyenTrongGroup from "@/components/pages/quan-tri-he-thong/quyen/DanhSachQuyenTrongGroup";
import MandateOtpConfirmModal from "@/components/pages/quan-tri-he-thong/MandateOtpConfirmModal";
import { callApiAffectedOtpUsersGroup } from "@/api/group";
import { mapGetters } from "vuex";
import { NAME_GROUP_TAB } from "../../../../constants/constants";

export default {
  name: "CapNhatGroup",
  data() {
    return {
      BO_QUA_BUTTON_LABEL: BO_QUA_BUTTON_LABEL,
      internalChiTietVaiTro: {},
      activeTab: GROUP_TAB.THONG_TIN_GROUP,
      GROUP_TAB: GROUP_TAB,
      NAME_GROUP_TAB: NAME_GROUP_TAB,
      disabledItem: true,
      isLoadingAction: false,
      internalAppId: null,
      isShowNguoiDung: false,
      // T4+5 UC13.4: id modal + số liệu affected-users để confirm khi bật mandate OFF->ON.
      MANDATE_MODAL_ID: "mandate-otp-confirm-group",
      mandateAffectedCount: 0,
      mandateAffectedSampleNames: [],
    };
  },
  components: {
    FormGroup,
    DanhSachNguoiDungTheoGroup,
    DanhSachVaiTroTheoGroup,
    DanhSachQuyenTrongGroup,
    MandateOtpConfirmModal,
  },
  computed: {
    ...mapGetters({
      chiTietGroup: "group/chiTietGroup",
      danhSachApp: "app/tatCaApp",
    }),
    danhSachAppNoiBo() {
      if (
        this.danhSachApp &&
        this.chiTietGroup &&
        this.chiTietGroup.applicationIds
      ) {
        return this.danhSachApp.filter((x) =>
          this.chiTietGroup.applicationIds.includes(x.id)
        );
      } else {
        return [];
      }
    },
  },
  created() {
    this.activeTab = location.hash;
    if (this.$route.params.id !== "tao-moi") {
      this.getChiTiet()
    }
  },
  watch: {
    chiTietGroup: {
      handler() {
        this.internalChiTietGroup = Object.assign(
          {},
          this.internalChiTietGroup,
          this.chiTietGroup
        );
        if (
          this.chiTietGroup.applicationIds &&
          this.chiTietGroup.applicationIds.length === 1
        ) {
          this.internalAppId = this.chiTietGroup.applicationIds[0];
        }
      },
    },
  },
  methods: {
    getChiTiet () {
      this.$store.dispatch("group/layChiTietGroup", {
        id: this.$router.currentRoute.params.id,
      });
    },
    changeCurrentTab(currentTab, giaTriCurrentTab) {
      this.$router
        .push({
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.GROUP.SUA,
          hash: `#${currentTab}`,
          params: { items: `${giaTriCurrentTab}` },
        })
        .catch(() => {});  
      this.internalAppId = null  
      this.getChiTiet()  
      this.activeTab = `#${currentTab}`
    },
    lamMoi() {
      if (this.$route.params.id == "tao-moi") {
        this.$refs["cap-nhat-group"].lamMoi();
      } else {
        this.getChiTiet()
      }
      
    },
    async taoMoiGroup() {
      const isValid = await this.$refs[
        "cap-nhat-group"
      ].$refs.observer.validate();
      const $vm = this;
      this.disabledItem = true;
      if (isValid) {
        this.isLoadingAction = true;
        this.$store
          .dispatch(
            "group/themMoiGroup",
            this.$refs["cap-nhat-group"].getInternalForm()
          )
          .then((response) => {
            this.isLoadingAction = false;
            if (response.data.succeeded) {
              this.disabledItem = false;
              $vm.$toasted.clear();
              $vm.$toasted.global.showSuccessMessage({
                message: THEM_MOI_GROUP_THANH_CONG,
              });
              this.$router.push({
                params: { id: response.data.data },
              });
              this.$store.dispatch("group/layChiTietGroup", {
                id: this.$router.currentRoute.params.id,
              });
            }
          })
          .catch((err) => {
            this.isLoadingAction = false;
            this.$toasted.clear();
            this.$toasted.global.showErrorMessage({
              message: err.data.message,
            });
          });
      }
    },
    boQua() {
      this.$router.push({
        name: ROUTE_NAME.QUAN_TRI_HE_THONG.GROUP.NAME,
      });
    },
    async capNhatGroup() {
      const isValid = await this.$refs[
        "cap-nhat-group"
      ].$refs.observer.validate();
      if (!isValid) return;

      // T4+5 UC13.4: detect bật mandate OFF->ON. Cờ CŨ = detail đang lưu; cờ MỚI = toggle form.
      // OFF->ON -> hỏi affected-users + confirm. Tắt (ON->OFF) / không đổi -> lưu thẳng.
      const wasOn = !!(this.chiTietGroup && this.chiTietGroup.requireOtpOnLogin);
      const willBeOn = this.$refs["cap-nhat-group"].getRequireOtpOnLogin();
      if (!wasOn && willBeOn) {
        await this.moModalXacNhanMandate();
        return; // chờ user Xác nhận -> onConfirmMandateGroup dispatch.
      }
      this.doCapNhatGroup();
    },
    async moModalXacNhanMandate() {
      const groupId = this.$router.currentRoute.params.id;
      try {
        const res = await callApiAffectedOtpUsersGroup({ groupId });
        const data = (res && res.data && res.data.data) || {};
        this.mandateAffectedCount = data.count || 0;
        this.mandateAffectedSampleNames = data.sampleNames || [];
      } catch (e) {
        this.mandateAffectedCount = 0;
        this.mandateAffectedSampleNames = [];
      }
      this.$bvModal.show(this.MANDATE_MODAL_ID);
    },
    onConfirmMandateGroup() {
      this.$bvModal.hide(this.MANDATE_MODAL_ID);
      this.doCapNhatGroup();
    },
    doCapNhatGroup() {
      const $vm = this;
      let payload = this.$refs["cap-nhat-group"].getInternalForm();
      payload.isDeleted = payload.isDeleted || false;
      this.isLoadingAction = true;
      this.$store
        .dispatch("group/capNhatGroup", payload)
        .then((response) => {
          this.isLoadingAction = false;
          if (response.data.succeeded) {
            $vm.$toasted.clear();
            $vm.$toasted.global.showSuccessMessage({
              message: CAP_NHAT_GROUP_THANH_CONG,
            });
            this.$store.dispatch("group/layChiTietGroup", {
              id: this.$router.currentRoute.params.id,
            });
          }
        })
        .catch((err) => {
          this.isLoadingAction = false;
          this.$toasted.clear();
          this.$toasted.global.showErrorMessage({
            message: err.data.message,
          });
        });
    },
  },
};
</script>
